import { useAuth } from "@/app/AuthContext";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";

/**
 * Signed in, and allowed nothing.
 *
 * Reached when `get_user` answers 403: the account authenticated, but holds no Cognito group this
 * fleet maps to a role. Showing the login page instead would sign the same account straight back
 * in, so this is the screen that stops the loop and says why.
 */
export function AccessDenied() {
  const { logout } = useAuth();

  return (
    <main className="flex min-h-dvh items-center justify-center p-4">
      <Card className="w-full max-w-sm p-8 shadow-md">
        <h1 className="text-xl font-semibold tracking-tight">No access</h1>
        <p className="mt-2 text-sm text-text-muted">
          You are signed in, but your account is not in a group that grants access to this app. Ask
          an administrator to add you to one, then sign in again.
        </p>

        <Button fullWidth className="mt-8" onClick={() => void logout()}>
          Sign out
        </Button>
      </Card>
    </main>
  );
}
